import {IAppState} from '@/interfaces/app-state.interface';
import {ActionContext} from 'vuex';
import {IDialog, IDialogStoreState} from '@/modules/Popup/interfaces/dialog.interface';
import Vue from 'vue';
import router from "@/router";
import _ from "lodash";
import {isMobile} from "mobile-device-detect";

type DialogActionContext = ActionContext<IDialogStoreState, IAppState>;

const defaultState: IDialogStoreState = {
  activePopup: {
    blockName: '',
    dialogName: '',
  },
  stackPopup: [],
  auth: {
    loginSelectCorp: false,
  },
  carList: {
    uploadCrsExcel: false,
  },
  car: {
    confirmArchive: false,
  },
  registration: {
    ofertaPopup: false,
  },
  profile: {
    changePasswordPopup: false,
    changeEmailPopup: false,
    accountLogPopup: false,
    accountPopup: false,
  },
  reports: {
    reportMovementsChange: false,
    selectMovementPopup: false,
  },
  barriers: {
    openBarrier: false,
    demoMoves: false,
    barrierLog: false,
    trailerPopup: false,
    similarNumbers: false,
  },
  home: {
    favoriteCars: false,
    getAccess: false,
    installAppInstruction: false,
  },
  parksConfig: {
    parkEvents: false,
    parkEventsLog: false,
  },
  payment: {
    balancePopup: false,
    payByCardPopup: false,
    bankAccountDocument: false,
    bankIframePopup: false,
    cantExitPopup: false,
    claimsPopup: false,
  },
  allPages: {
    feedbackPopup: false,
    antiTheftCars: false,
    eventsLog: false,
    appMediaPopup: false,
    cashPayPopup: false,
    decodeMoneyPopup: false,
    inputCarNumber: false,
    deviceStatsPopup: false,
    corpPopup: false,
    cookieBannerPopup: false,
  },
  payload: {},
  updatePopup: false,
};

export const DialogStore: IDialogStoreState = {
  // @ts-ignore
  namespaced: true,
  state: { ...defaultState },
  getters: {
    getPopupPayload: (state: IDialogStoreState) => (currentPopup: { blockName: string; dialogName: string; }) => {
      let payload = state.payload;
      let blockName = currentPopup.blockName;
      let dialogName = currentPopup.dialogName;
      let needUpdate = state.updatePopup;

      return payload && payload[blockName] && payload[blockName][dialogName]
        ? payload[blockName][dialogName]
        : {};
    },
  },
  mutations: {
    setPropertyInState(state: IDialogStoreState, data: { name: string; value: any; }) {
      Vue.set(state, data.name, data.value);
    },
    openDialog(state: IDialogStoreState, data: IDialog.PopupData) {
      let activePopup: IDialog.IActivePopup = {
        blockName: data.blockName,
        dialogName: data.dialogName,
      };
      Vue.set(state, 'activePopup', {...activePopup});
      state.stackPopup.unshift({...activePopup});
      Vue.set(state[data.blockName], data.dialogName, true);
      if (data.payload) {
        if (state.payload[data.blockName]) {
          state.payload[data.blockName][data.dialogName] = data.payload;
        }
        else {
          state.payload[data.blockName] = { [data.dialogName]: data.payload };
        }
      }
    },

    closeDialog(state: IDialogStoreState, payload: IDialog.PopupData) {
      state.stackPopup.shift();
      if (state.stackPopup.length) {
        Vue.set(state, 'activePopup', {
          blockName: state.stackPopup[0].blockName,
          dialogName: state.stackPopup[0].dialogName,
        });
      }
      else {
        Vue.set(state, 'activePopup', {blockName: '', dialogName: ''});
      }
      Vue.set(state[payload.blockName], payload.dialogName, false);
      if (state.payload[payload.blockName]) {
        state.payload[payload.blockName][payload.dialogName] = {};
      }
      else {
        state.payload[payload.blockName] = {};
      }
    },

    updatePayloadProp(state: IDialogStoreState, payload: { name: string, value: any }) {
      Vue.set(state.payload, payload.name, payload.value);
    },

    updateActivePopupPayload(state: IDialogStoreState, payload: any) {
      state.payload[state.activePopup.blockName][state.activePopup.dialogName] = {...payload};
    },

    closeAllDialogs(state: IDialogStoreState) {
      for (let block in defaultState) {
        for (let dialog in defaultState[block]) {
          Vue.set(state[block], dialog, false);
        }
      }
      Vue.set(state, 'payload', {});
      Vue.set(state, 'stackPopup', []);
    },
  },
  actions: {
    openDialog({commit, rootState}: DialogActionContext, payload: IDialog.PopupData) {
      commit('openDialog', payload);

      // if (isMobile) {
      //   const routingParams = {
      //     name: rootState.route.name,
      //     query: {
      //       ...rootState.route.query,
      //       dialog: payload.dialogName,
      //     }
      //   };
      //
      //   if (payload.secondaryPopup) {
      //     routingParams.query.notClose = true;
      //     router.replace(routingParams);
      //   }
      //   else {
      //     router.push(routingParams);
      //   }
      // }
    },
    closeDialog({commit, rootState}: DialogActionContext, payload: IDialog.PopupData) {
      commit('closeDialog', payload);

      // if (isMobile) {
      //   const query = _.clone(rootState.route.query);
      //   if (query.dialog && !payload.savePayload) {
      //     router.go(-1);
      //   }
      // }
    },
    closeAllDialogs({commit}: DialogActionContext) {
      commit('closeAllDialogs');
    },
    async reloadPopup({commit}: DialogActionContext) {
      commit('setPropertyInState', { name: 'updatePopup', value: true });
      await Vue.nextTick();
      commit('setPropertyInState', { name: 'updatePopup', value: false });
    },
  },
};
